export default __webpack_public_path__ + "static/standard-room-c3dd07781d279e6e0e76cdcb85cd7678.jpg";